import schema from './schema.json';

export default {
  ...schema,

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      if (data.contacts) {
        data.contacts = data.contacts.map((item, index) => ({
          id: item.id || String(index + 1),
          ...item
        }));
      }
      if (data.socials) {
        data.socials = data.socials.map((item, index) => ({
          id: item.id || String(index + 1),
          ...item
        }));
      }
      return { ...schema.default, ...data };
    }
    return data;
  }
};
